//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mutation from '~/queries/mutations/subscribeToProductEmailNotification.graphql';

export default {
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            email: '',
            disabled: false,
        };
    },
    async mounted() {
        try {
            await this.$recaptcha.init();
        } catch (e) {
            console.error(e);
        }
    },
    beforeDestroy() {
        this.$recaptcha.destroy();
    },
    computed: {},
    methods: {
        toggleForm() {
            if (!this.disabled) {
                this.show = !this.show;
            }
        },
        async submit() {
            try {
                const token = await this.$recaptcha.execute('login');
                const data = await this.$apollo.mutate({
                    mutation,
                    variables: {
                        input: {
                            email: this.email,
                            product_id: this.id,
                            notification_code: 'back_in_stock',
                        },
                    },
                    context: {
                        headers: {
                            'X-ReCaptcha': token,
                        },
                    },
                });
                this.$notify.success(this.$t('productemailsubscribe.success'));
                this.disabled = true;
                this.show = false;
            } catch (e) {
                this.$notify.error(e);
            }
        },
    },
};
